import BadgeBase from "../BadgeBase";

export const sourceConfig = {
  "Google planilhas": { label: "Google Planilhas", tone: "blue" },
  "Google Planilhas": { label: "Google Planilhas", tone: "blue" },
  ERP: { label: "ERP", tone: "warning" },
  Excel: { label: "Excel", tone: "success" },
  API: { label: "API", tone: "blue" },
  "API Rest": { label: "API", tone: "blue" },
  "Api Rest": { label: "API", tone: "blue" },
  api_rest: { label: "API", tone: "blue" },
  WEBHOOK: { label: "API", tone: "blue" },
  Webhook: { label: "API", tone: "blue" },
  Principal: { label: "Principal", tone: "primary" },
};

export function getSourceBadgeConfig(value) {
  return sourceConfig[value] || { label: "Desconhecido", tone: "neutral" };
}

export default function SourceBadge({ value, size = "md", sx }) {
  const config = getSourceBadgeConfig(value);

  return (
    <BadgeBase tone={config.tone} size={size} sx={sx}>
      {config.label}
    </BadgeBase>
  );
}
